import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, ListItemButton, ListItemIcon, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { trackActivity } from '../../../utils/mixpanel';

const ApproverModal = ({ modalData, approvalData, onSearchUserField, toggleModalFn, pageTitle, remarks }) => {
    const [filteredUsers, setFilteredUsers] = useState(approvalData);
    useEffect(() => {
        const newFilteredUsers = approvalData?.filter(user =>
            user?.name?.toLowerCase().includes(modalData?.searchUser?.toLowerCase()) ||
            user?.email?.toLowerCase().includes(modalData?.searchUser?.toLowerCase())
        );
        setFilteredUsers(newFilteredUsers);
    }, [modalData?.searchUser, approvalData]);
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Approvers`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                open={modalData?.approverModal}
                aria-labelledby="scroll-dialog-title"
                className='add-lease-dialog'
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="scroll-dialog-title">Approver(s)</DialogTitle>
                <DialogContent
                    dividers={true}
                    sx={{
                        p: 2,
                        height: '450px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                            bgcolor: 'background.paper',
                            pb: 1,
                        }}
                    >
                        <TextField
                            fullWidth
                            size="small"
                            margin="normal"
                            value={modalData?.searchUser}
                            slotProps={{ htmlInput: { maxLength: 255 } }}
                            onChange={onSearchUserField}
                            variant='outlined'
                            placeholder='Search by name..'
                        />
                    </Box>
                    <Box sx={{ overflow: 'auto', border: '1px solid #c3c3c3', borderRadius: '4px', }}>
                        <List sx={{ width: '100%', bgcolor: 'background.paper', p: 0 }}>
                            {filteredUsers?.length > 0 ? (
                                filteredUsers.map((user, index) => (
                                    <ListItem
                                        key={user.id}
                                        sx={{ borderBottom: index < filteredUsers.length - 1 ? "1px solid #c3c3c3" : 'none' }}
                                        disablePadding
                                    >
                                        <ListItemButton role={undefined} dense>
                                            {/* <ListItemIcon>
                                                <DeleteIcon fontSize='small' color='error' onClick={() => { openDeleteModal(user.id); handleItemClicked('DeleteIcon') }} />
                                            </ListItemIcon> */}
                                            <ListItemText primary={`${user?.name ?? ""} ${user?.last_name ? user?.last_name : ""}`} secondary={user?.email || ""} />
                                        </ListItemButton>
                                    </ListItem>
                                ))
                            ) : (
                                <Box className="no-record-found">No Records Found</Box>
                            )}
                        </List>
                    </Box>
                    {pageTitle === "Claim" && remarks ? (
                        <TextField
                            label="Comments"
                            value={remarks}
                            variant="outlined"
                            size="small"
                            multiline
                            rows={3}
                            fullWidth
                            disabled
                            slotProps={{ inputLabel: { shrink: true } }}
                            sx={{ mt: 1 }}
                        />
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <div>
                        <div style={{ float: 'right' }}>
                            <Button className='cancel-btn' onClick={() => { toggleModalFn(); handleItemClicked('Close Button') }} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Close</Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ApproverModal;







